// Application Status
export const REQUESTED_CODE: string = 'RQST';
export const PRESCREENED_CODE: string = 'PRSC';
export const PRESCREENING_FAILED_CODE: string = 'PREF';
export const VERIFIED_CODE: string = 'VERP';
// export const VERIFICATION_FAILED_CODE: string = 'VERF';
export const PAYMENT_MADE_CODE: string = 'FATCH';
export const PAYMENT_VERIFIED_CODE: string = 'PAYV';
export const PAYMENT_VERIFICATION_FAILED_CODE: string = 'PAYF';
// payment confirmed for online payment used after second time inspection payment id completed
export const PAYMENT_CONFIRMED_CODE: string = 'PCONF'; 
export const INSPECTED_CODE: string = 'INSP';
export const SELF_INSPECTION_PASSED_CODE: string = 'SIP';
export const SELF_INSPECTION_FAILED_CODE: string = 'SIF';
export const INSPECTION_FAILED_CODE: string = 'INSF';
export const WITHDRAWN_CODE: string = 'WITH';
export const APPROVED_CODE: string = 'APR';
export const REJECTED_CODE: string = 'REJ';
export const CERTIFICATE_GENERATED: string = 'CERG';
export const CSO_ASSIGNED_CODE: string = 'ASDP';
export const INSPECTOR_ASSIGNED_CODE: string = 'ASDI';
export const OFFICER_ASSIGNED_CODE: string = 'ASGI';
export const FINAL_FILE_SUBMITTED_CODE : string = 'FFS';
export const APPROVED_FOR_INSPECTION_CODE : string = 'AFI';
export const RETURNED_TO_FILE_SUBMISSION_CODE : string = 'RTFS';
export const SUBMIT_FOR_APPROVAL_CODE: string = 'SFA';
export const RETURN_TO_INSPECTOR_CODE: string = 'RTI';
export const RETURN_TO_CSO_CODE: string = 'RTC';
export const RETURN_TO_INSPECTOR_TEAM_LEADER_CODE: string = 'RTITL';
export const SUBMIT_FOR_REJECTION_CODE: string = 'SFR';
export const RETURN_TO_APPLICANT_CODE: string = 'RTA';
export const INSPECTION_REJECTED_CODE: string = 'IREJ';
export const UNDER_REVIEW_CODE: string = 'UREV';
export const LEGACY_DATA_EDITED_CODE: string = 'LDE';
export const FIR_REQUESTED: string = 'FIRR';
export const FIR_SUBMITTED: string = 'FIRS';
export const LEGACY_FIR_SUBMITTED: string = 'LFIRS';
export const FI_SUBMITTED: string = 'FIS';
export const FIR_REQUESTED_AFTER_INSPECTION: string= 'FIRRAI';
export const FIR_SUBMITTED_AFTER_INSPECTION: string='FIRSAI';
export const FI_SUBMITTED_AFTER_INSPECTION: string='FISAI';
export const ARCHIVED: string = 'ARCH';
export const DELETED: string = 'DEL';
export const INFO_FOR_INSPECTION_REQUESTED = 'IFIR';
export const INFO_FOR_INSPECTION_SUBMITTED = 'IFIS';
export const PENDING_PAYMENT = 'PPEND';
export const UNDO_DELETE: string = 'UDEL';
export const UNDO_DELETE_LABEL: string = 'Undo Delete';
export const DELETE_APPLICATION: string = 'Delete Application';
export const RETURN_TO_CSO_TEAM_LEADER_CODE = 'RTCTL';
export const CLOSED = 'CLOSED';
export const VOID = 'VOID';
export const GENERATE_CERTIFICATE: string = 'Generate Certificate';
export const PAYMENT_REFERRAL: string = 'Payment Referral';
export const INSPECTION_RESULT: string = 'Inspection Result';
export const PREVIEW_NOTIFICATION_LETTER: string = 'Preview Notification Letter';
export const CERTIFICATE_PRINTED_NAME = 'Certificate Printed';
export const CERTIFICATE_DOWNLOADED_NAME = 'Certificate Downloaded';
export const QUARANTINED = 'QURT';
export const UNDO_QUARANTINE: string = 'UQUR';
export const UNDO_QUARANTINE_LABEL: string = 'Undo Quarantine';
export const LICENSE_CANCELLED: string = 'LCC';
export const LICENSE_SUSPENDED: string = 'LCS';
export const UNDO_LICENSE_SUSPENSION: string = 'ULCS';
export const UNDO_LICENSE_SUSPENSION_LABEL: string = 'Undo License Suspension';
export const UNDO_WITHDRAW_LABEL : string = 'Undo Withdraw';
 
export const DISAGREEMENT_NOTIFIED : string= "NTDS";

// Test Strings
export const PASS: string = 'Pass';
export const FAIL: string = 'Fail';
export const WITHDRAW: string = 'Withdraw';
export const RETURN: string = 'Return';
export const REQUEST: string = 'Request';
export const SUBMIT: string = 'FIR Submit';
export const APPROVE_CLOSE: string = 'Approve and Close';
export const VOID_CERTIFICATE: string = 'Void Certificate';
export const GENERATE: string = 'Generate';
export const QUARANTINE: string = 'Quarantine';
export const CANCEL: string = 'Cancel';
export const SUSPEND: string = 'Suspend';
export const REVOKE: string = 'Revoke';
export const RECOMMEND: string = 'Recommend';
export const SUBMITAPP: string = 'Submit for Approval';
export const APPROVE: string = 'Approve'; 
export const SUBMITPASS: string = 'Submit'; 
export const NOTIFY: string = 'Notify'; 
export const CLOSE: string = 'Close'; 

//User Roles
export const CSO: string = 'LCSO';
export const INSPECTOR: string = 'INS';
export const APPLICANT: string = 'IPA';
export const PIP_APPLICANT: string = 'PIPA';
export const DIRECTOR: string = 'LCSD';
export const ADMINISTRATOR: string = 'ADM';
export const CSO_TEAM_LEADER: string = 'LCST';
export const INSPECTOR_TEAM_LEADER: string = 'INTL';
export const DATA_ENTRY_CLERK: string = 'DEC';
export const SUPER_ADMIN: string = 'SADM';
export const AUDITOR: string = 'AUD';
export const GMP_COORDINATOR: string = 'GCO';
export const GMP_OFFICER: string = 'GMO';
export const CGMP_INSPECTOR: string = 'CGI';
export const GMP_TASK_FORCE: string = 'TFO';
export const REGISTRANT: string = 'REGISTRANT';
export const FINANCIAL_OFFICER: string = 'FIOF'

//Facility Type
export const MANUFACTURER: string = 'Manufacturer';
export const IMPORTER: string = 'Importer';
export const WHOLESALER: string = 'Wholesaler';
export const EXPORTER: string = 'Exporter';
export const MANUFACTURER_ID: number = 4;

//Food Manufacturing Risk Levels
export const HIGH_RISK_LEVEL_FOOD: string = 'PHRF';
export const MEDIUM_RISK_LEVEL_FOOD: string = 'PMRF';
export const LOW_RISK_LEVEL_FOOD: string = 'PLRF';
//Food Manufacturing Risk Levels
export const HIGH_RISK_LEVEL_FOOD_NAME: string = 'Producer of high-risk food products';
export const MEDIUM_RISK_LEVEL_FOOD_NAME: string = 'Producer of medium-risk food products';
export const LOW_RISK_LEVEL_FOOD_NAME: string = 'Producer of low-risk food products';

// Manufacturing Levels
export const HIGHER_MANUFACTURING = 'HGR';
export const MEDIUM_MANUFACTURING = 'MDM';
export const LOWER_MANUFACTURING = 'LWR';

export const HIGHER_MANUFACTURING_NAME = 'Higher';
export const MEDIUM_MANUFACTURING_NAME = 'Medium';
export const LOWER_MANUFACTURING_NAME = 'Lower';

//OwnerShip Type
export const PLC = 'PLC';
export const PRIVATE = 'PRIV';

//ApplicantType 
export const TECHNICAL_MANAGER: string = 'TMGR';
export const FOCAL_PERSON: string = 'FPRSN';
export const APPLICANT_TYPE_MANUFACTURER: string = 'MANU';
export const LICENSE_HOLDER: string = 'LICHL';
export const LOCAL_AGENT: string = 'LOA';
export const REPRESENTATIVE: string = 'REP';


//Product Type
export const PRODUCT_TYPE_FOOD: string = 'Food';
export const PRODUCT_TYPE_MEDICINE: string = 'Medicine';
export const PRODUCT_TYPE_MED_DEVICES: string = 'Medical Device';
export const PRODUCT_TYPE_COSMETICS: string = 'Cosmetics';
export const PRODUCT_TYPE_TOBACCO: string = 'Tobacco';
export const PRODUCT_TYPE_MED_AND_MED_DEVICES: string = 'Medicine and Medical devices';
export const PRODUCT_TYPE_SMALL_SCALE_COSMETICS: string = 'Small Scale Cosmetics';
export const PRODUCT_TYPE_SMALL_SCALE_MEDICINE: string = 'Small Scale Medicine';
export const PROUDCT_TYPE_BARRIER_FACE_MASK: string = 'Barrier Face Mask'
export const PRODUCT_TYPE_MEDICAL_GAS: string = 'Medical Gas';
export const TOBACCO: string = 'Tobacco';



export const PAYMENT_REFERENCE_ID= 35;
export const INSPECTION_RESULT_REFERENCE_ID= 33;
export const LICENSE_CANCELLATION_LETTER_REFERENCE_ID = 67;
export const LICENSE_SUSPENSION_LETTER_REFERENCE_ID = 68;
export const FINAL_FILE_FOR_INSPECTION_PREPARATION = 87;
export const GMP_REVOCATION_LETTER_ID = 98
export const GMP_FINAL_PAYMENT_REFERENCE_ID = 99;
export const CONSENT_DOC_REFERENCE_ID = 101;
export const ADDITIONAL_DOCS_FOR_INSPECTION_REFERENCE_ID = 102;
export const TASK_FORCE_REPORT_REFERENCE_ID = 106;
export const SUPPORT_LETTER_REFERENCE_ID = 107;
export const FINAL_PAYMENT_REQUEST_REFERENCE_ID = 108;
export const CAPA_PLAN_REQUEST_REFERENCE_ID = 109; 
export const NOTIFY_DISAGREEMENT_REFERENCE_ID =111;
export const TASK_FORCE_REVIEW_MINUTE_REFERENCE_ID =112;
export const IMPLEMENTATION_EVIDENCE_REFERENCE_ID =103;
export const PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID =110;
export const BANK_TRANSFER_SLIP_REFERENCE_ID =117; 
export const GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE_REFERENCE_ID = 118;
export const GMP_FINAL_BANK_TRANSFER_SLIP_REFERENCE_ID = 119;
export const CAPA_PLAN_ANDOR_IMPLEMENTATION_ASSESSEMENT_REPORT_REFERENCE_ID = 121;
export const  IMPLEMENTATION_EVIDENCE_ASSESSEMENT_REPORT_REFERENCE_ID = 122;


//Application Status
export const PRESCREENING_PASS: string = 'Prescreened'
export const PRESCREENING_FAILED: string = 'Prescreening Failed'
export const REQUESTED_MESSAGE: string = 'Requested';
export const PRESCREENED_MESSAGE: string = 'Prescreen';
export const PRESCREENING_FAILED_MESSAGE: string = 'Prescreening Failed';
export const VERIFIED_MESSAGE: string = 'Verification Passed';
export const VERIFICATION_FAILED_MESSAGE: string = 'Verification Failed';
export const PAYMENT_MADE_MESSAGE: string = 'Fee Attached';
export const PAYMENT_VERIFIED_MESSAGE: string = 'Payment Verified';
export const PAYMENT_VERIFICATION_FAILED_MESSAGE: string = 'Payment Failed';
export const INSPECTED_MESSAGE: string = 'Inspection Passed';
export const INSPECTION_FAILED_MESSAGE: string = 'Inspection Failed';
export const WITHDRAWN_MESSAGE: string = 'Application Withdrawn';
export const APPROVED_MESSAGE: string = 'Application Approved';
export const REJECTED_MESSAGE: string = 'Application Rejected';
export const CSO_ASSIGNED_MESSAGE: string = 'Assigned to Prescreener';
export const INSPECTOR_ASSIGNED_MESSAGE: string = 'Assigned to Inspector';
export const SUBMIT_FOR_APPROVAL_MESSAGE: string = 'Submit for Approval';
export const RETURN_TO_INSPECTOR_MESSAGE: string = 'Return to Inspector';
export const RETURN_TO_INSPECTOR_TEAM_LEADER_MESSAGE: string = 'Return to Inspector Team Leader'; 
export const SUBMIT_FOR_REJECTION_MESSAGE: string = 'Submit for Rejection';
export const RETURN_TO_APPLICANT_MESSAGE: string = 'Return to Applicant';
export const INSPECTION_REJECTED_MESSAGE: string = 'Inspection Rejected';
export const UNDER_REVIEW_MESSAGE: string = 'Under Review';
export const INSPECTION_TOBE_EDITED: string = 'Inspection to be edited';

//Country Code
export const ETH_COUNTRY_CODE = '+251'

//Professional Types
export const TECHNICAL_LEADER_CODE: string = 'TL';
export const PRODUCTION_MANAGER_CODE: string = 'PM';
export const QUALITY_ASSURANCE_CODE: string = 'QA';
export const STORE_MANAGER_CODE: string = 'SM';
export const HYGIENE_AND_SANITATION_EXPERT_CODE: string = 'HSE';
export const Quality_CONTROL_CODE: string = 'QC';
export const PHYSICO_CHEMICAL_EXPERT_CODE: string = 'PCE';
export const MICROBIOLOGIST_CODE: string = 'MB';
export const WAREHOUSE_MANAGER_CODE: string = 'WM';

export const TECHNICAL_LEADER_NAME: string = 'Technical Manager';
export const PRODUCTION_MANAGER_NAME: string = 'Production Manager';
export const QUALITY_ASSURANCE_NAME: string = 'Quality Assurance Supervisor Head';
export const Quality_CONTROL_NAME: string = 'Quality Control';
export const STORE_MANAGER_NAME: string = 'Store Manager';
export const HYGIENE_AND_SANITATION_EXPERT_NAME: string = 'Hygiene and Sanitation Expert';
export const PHYSICO_CHEMICAL_EXPERT_Name: string = 'Physico-chemical Expert';
export const MICROBIOLOGIST_Name: string = 'Microbiologist';

export const MED_DEPARTMENT: string = 'MED';
export const FOOD_DEPARTMENT: string = 'FOOD';
export const TOBACCO_DEPARTMENT: string = 'TOB';
export const PROFESSIONALS_MAP = {
  TL: 'Technical Manager',
  PM: 'Production Manager',
  QA: 'Quality Assurance Supervisor Head',
  QC: 'Quality Control',
  SM: 'Store Manager',
  HSE: 'Hygiene and Sanitation Expert',
  PCE: 'Physico-chemical Expert',
  MB: 'Microbiologist',
};

export const DATA_TYPE_ADDRESS_CHANGE = 'Location';
export const DATA_TYPE_ADDITIONAL_PRODUCT = 'SpecificProductData';
export const DATA_TYPE_PROFESSIONAL_CHANGE = 'Professional';
export const DATA_TYPE_FACILITY_NAME_CHANGE ='FacilityNameChange';
export const DATA_TYPE_PREMISE_MODIFICATION = 'PremiseModification';
export const DATA_TYPE_OWNERSHIP_CHANGE = 'Ownership';
export const DATA_TYPE_PRODUCT_TYPE_CHANGE = 'ProductType';
export const DATA_TYPE_NONE = 'None';
export const DATA_TYPE_ORGANIZATION = 'Organization';
// Manufacturing Risk Level
export const MANUFACTURING_RISK_LEVEL_LOW: string = 'PLRF';
export const MANUFACTURING_RISK_LEVEL_HIGH: string = 'PHRF';
export const MANUFACTURING_RISK_LEVEL_MEDIUM: string = 'PMRF';
export const MANUFACTURING_RISK_LEVEL_SPECIAL: string = 'PSNPF';

// Manufacturing Level
export const MANUFACTURING_LEVEL_HIGHER: string = 'HGR';
export const MANUFACTURING_LEVEL_MEDIUM: string = 'MDM';
export const MANUFACTURING_LEVEL_LOWER: string = 'LWR';

//Qualification Types 
export const APPLIED_BIOLOGY = 'Applied Biology';
export const APPLIED_CHEMISTRY = 'Applied Chemistry';
export const BIOCHEMISTRY = 'Biochemistry';
export const BIOMEDICAL_ENGINEER = 'Biomedical Engineer';
export const CHEMISTRY = 'Chemistry'
export const DRUGGIST = 'Druggist'
export const ENVIRONMENTAL_HEALTH = 'Environmental Health'
export const ENVIRONMENTAL_SCIENCE = 'Environmental Science' 
export const FOOD_ENGINEERING = 'Food Engineering'
export const FOOD_PROCESS_ENGINEERING = 'Food Process Engineering'
export const FOOD_SCIENCE_AND_TECHNOLOGY = 'Food Science and Technology'
export const FOOD_SCIENCE_AND_POST_HARVEST_TECH = 'Food Science and Post Harvest Technology'
export const FOOD_SCIENCE_AND_NUTR = 'Food Science and  Nutrition'
export const LAB_TECH = 'Lab Technician'
export const MICROBIOLOGIST  = 'Microbiologist'
export const NURSE = 'Nurse'
export const PATHOLOGY = 'Pathology'
export const PHARMACIST = 'Pharmacist'
export const SEN_PHARMACIST = 'Senior Pharmacist'
export const PHYSICOCHEMICAL = ' Physicochemical'
export const SENIOR_PHARMACIST = 'Senior Pharmacist'
export const RADIOLOGY = 'Radiology'
export const SANITARY_SCIENCE = 'Sanitary Science'
export const BIOMEDICAL_EQP_ENG = 'Biomedical Equipment Maintenance Engineer'
export const MED_LAB_TECH = 'Medical Laboratory Technologist'
export const MED_EQUIP_ENG = 'Medical Equipments Maintenance Engineer'
export const DENTAL_SCIENCE_PROF = 'Dental Science Professional'
export const OPHTHALMOLOGIST = 'Ophthalmologist'
export const RADIOGRAPHY_TECH = 'Radiography Technologist'
export const OTHER =  'Other'
export const FOOD_TECH = 'Food Technology'
export const DAIRY_TECH = 'Dairy Technology'
export const MEAT_TECH = 'Meat Technology'
export const VETERINARY_MICROBIOLOGY = 'Veterinary Microbiology'
export const FOOD_SAFETY_AND_QUALITY = 'Food Safety and Quality'
export const FOOD_BIOTECHNOLOGY_AND_FEMENTATION_TECH = 'Food Biotechnology and Fermentation Technology'
export const FOOD_MICROBIOLOGY = 'Food Microbiology'
export const OTHER_RELATED_TO_FOOD_SCIENCE = 'Other Related to Food Science'
export const TEXTILE_ENG = 'Textile Engineer'
export const OPTICIAN = 'Optician'
export const OPTICAL_TECHNICIAN = 'Optical Technician'
export const OPTICAL_ENG = 'Optical Engineer'
export const MACHINE_OPERATOR = 'Machine Operator'
export const MECHANICAL_ENG = 'Mechanical engineer'
export const OPTOMETRIST = 'Optometrist'

export const PUBLIC_HEALTH = 'Public Health'
export const INDUSTRIAL_ENGINEER = 'Industrial Engineer'
export const PSYCHOLOGY = 'Psychology'
export const CHEMICAL_ENGINNER = 'Chemical Engineer'
export const INDUSTRIAL_CHEMISTRY = 'Industrial Chemistry'
export const BIOLOGY = 'Biology'

export const HEALTH_OFFICER = 'Health Officer'
export const MEDICAL_DOCTOR = 'Medical Doctor'
export const DENTAL_SURGEON = 'Dental Surgeon'
export const OCCUPATIONAL_HEALTH = 'Occupational Health'
export const PHYSIOTHERAPIST = 'Physiotherapist'
export const MIDWIFERY = 'Midwifery'

// Education Levels
export const DIPLOMA = 'Diploma';
export const TWELVE_DiPLOMA = '12th Diploma';
export const TENTH_GRADE = '10th Grade Complete';

//Document Remarks

export const NOT_VERIFIED = 'Not Verified';

export const FACILITY_CAT_GREEN = 'Green';
export const FACILITY_CAT_YELLOW = 'Yellow';
export const FACILITY_CAT_RED = 'Red';
export const FACILITY_CAT_UNCAT = 'Uncategorized';


export const CHANGE_TYPE_ADDRESS = 'Address Change';
export const CHANGE_TYPE_SPECIFIC_PRODUCT_CHANGE_OR_ADDITION = 'Specific Product Change Or Addition';
export const CHANGE_TYPE_PREMISE_MODIFICATION = 'Premise Modification';
export const CHANGE_TYPE_PROFESSIONAL_CHANGE = 'Professional Change';
export const CHANGE_TYPE_FACILITY_NAME = 'Facility Name Change';
export const CHANGE_TYPE_PRODUCT_LINE_ADDITION = 'Product Line Addition';
export const CHANGE_TYPE_OWNERSHIP_CHANGE = 'Ownership Change';
export const CHANGE_TYPE_PRODUCT_TYPE_CHANGE = 'Product Type Change Or Addition';
export const CHANGE_TYPE_TIN = 'Tin Change';


export const CHANGE_REF_TYPE_OWNERSHIP_CHANGE = 6;
export const CHANGE_REF_TYPE_PRODUCTION_MANAGER = 9;
export const CHANGE_REF_TYPE_QUALITY_ASSURANCE = 10;
export const CHANGE_REF_TYPE_PHYSICO_CHEMICAL_EXPERT = 11;
export const CHANGE_REF_TYPE_MICROBIOLOGIST = 12;
export const CHANGE_REF_TYPE_HYGINE_SANITATION = 13;






//Status color
export const COLOR_MAP = {
  RQST: 'badge badge-info',
  LDE: 'badge badge-info',
  SIP: 'badge badge-primary',
  PRSC: 'badge badge-primary',
  PREF: 'badge badge-warning',
  PEND: 'badge badge-warning',
  VERP: 'badge badge-primary',
  VERF: 'badge badge-warning',
  FATCH: 'badge badge-info',
  PAYV: 'badge badge-primary',
  PAYF: 'badge badge-warning',
  PCONF: 'badge badge-primary',
  SIF: 'badge badge-warning',
  INSP: 'badge badge-primary',
  INSF: 'badge badge-warning',
  WITH: 'badge badge-warning',
  APR: 'badge badge-primary',
  REJ: 'badge badge-danger',
  CERG: 'badge badge-primary',
  ASDP: 'badge badge-info',
  ASDI: 'badge badge-info',
  SFA: 'badge badge-info',
  RTI: 'badge badge-info',
  RTC: 'badge badge-info',
  RTITL: 'badge badge-info',
  SFR : 'badge badge-warning',
  RTA : 'badge badge-info',
  IREJ : 'badge badge-warning',
  UREV : 'badge badge-info',
  DEL : 'badge badge-danger',
  FIRR : 'badge badge-primary',
  FIRS : 'badge badge-primary',
  FIS : 'badge badge-info',
  ARCH : 'badge badge-secondary',
  RTCTL: 'badge badge-info',
  CLOSED : 'badge badge-danger',
  VOID : 'badge badge-warning',
  QURT : 'badge badge-warning',
  LCC: 'badge badge-danger',
  LCS: 'badge badge-warning',
  RAP: 'badge badge-info',
  RCNC: 'badge badge-warning',
  RCAP: 'badge badge-warning',
  ALEG: 'badge badge-primary',
  PALG: 'badge badge-primary',
  PRC: 'badge badge-danger',
  WAG: 'badge badge-warning',
  CAPS: 'badge badge-warning',
  FFI: 'badge badge-info',
  SCP: 'badge badge-primary', 
  SCF: 'badge badge-warning', 
  NCLG: 'badge badge-danger',
  GMS: 'badge badge-danger',
  GMC: 'badge badge-danger',
  GRVK: 'badge badge-danger',
  ALGC: 'badge badge-info',
  ASGI: 'badge badge-info',
  FFS: 'badge badge-info',
  AFI: 'badge badge-primary',
  RINP: 'badge badge-primary',
  RINF: 'badge badge-warning',
  RCPY: 'badge badge-primary',
  RCRA: 'badge badge-warning',
  FPR: 'badge badge-primary',
  FPA: 'badge badge-info',
  IFIR: 'badge badge-warning', 
  IFIS: 'badge badge-primary',
  CAPREQ: 'badge badge-info',
  CAPREJ: 'badge badge-warning',
  IMRREQ: 'badge badge-info',
  IMRS: 'badge badge-primary',
  IMRREJ: 'badge badge-warning',
  PAYA: 'badge badge-primary',
  PAYRC: 'badge badge-info',
  ATF: 'badge badge-info',
  PTFA: 'badge badge-primary',
  FTFA: 'badge badge-warning',
  FIRRBI: 'badge badge-primary',
  FIRRAI: 'badge badge-primary',
  FISBI: 'badge badge-info',
  FISAI: 'badge badge-info',
  FIRSAI : 'badge badge-primary',
  PPEND: 'badge badge-secondary',
  RPA: 'badge badge-primary',
  RPF: 'badge badge-warning',
  SAPR: 'badge badge-primary',
  TPAP: 'badge badge-primary',
TPRT: 'badge badge-warning',
TPSH: 'badge badge-info',
RDNT: 'badge badge-info',
URNT: 'badge badge-warning',
INRS: 'badge badge-info',
RRTI: 'badge badge-warning',
APCL: 'badge badge-danger',
RMSH: 'badge badge-info',
TFRU: 'badge badge-info',
RJRQ: 'badge badge-warning',
CIES: 'badge badge-info',
PRTA: 'badge badge-warning',
TPSB: 'badge badge-info',
ASTP: 'badge badge-info',
AIAI: 'badge badge-info',
FPAP: 'badge badge-primary',
RAAI: 'badge badge-info',
RFCR: 'badge badge-info', 
RIAI: 'badge badge-warning',
RTCR: 'badge badge-warning',
PRLG: 'badge badge-primary',
RACA: 'badge badge-warning',

FPRT: 'badge badge-warning',
RTIN: 'badge badge-warning',
RSIN: 'badge badge-info',
RDHR: 'badge badge-warning',
SIRS: 'badge badge-primary',

ASIE: 'badge badge-info',
RRIE: 'badge badge-warning', 
RAIE: 'badge badge-primary',
RPIE: 'badge badge-info' ,
RCIE: 'badge badge-info'

};

//Status color
export const FIR_ITEMS_DETAIL_MAP = {
  name: 'Facility Name',
  facilityTypeID:'Facility Type',
  productTypeID:'Product Type',
  specificProducts:'Specific Product',
  specificProductItems:'Specific Product Item',
  mLevelID:'Manufacturing Level',
  mrLevelID:'Manufacturing Risk Level',
  ownerName:'Owner Name',
  ownershipType: 'Ownership Type',
  ownerPhoneNumber:'Owner Phone',
  focalPerson:'Focal Person Name',
  tinNumber: 'Tin Number',
  regionID: 'Region',
  zoneID:'Zone',
  woredaID: 'Woreda',
  cityID:'City',
  kebele: 'Kebele',
  houseNo:'House No',
  branchOffice:'Branch Office',
  areaName:'Specific Location',
  phoneNo: 'Phone No',
  subCityID: 'Sub City'
};


// Document names
export const EXPERIENCE_LETTER_STORE_MANAGER_DOC = 'Experience Letter of Store manager';
export const CONSTRUCTION_PERMIT_LETTER_DOC = {
  "name": "Construction permit letter",
  "active": true,
  "required": true,
  "description": "Construction Minster occupancy permit letter",
  "id": 60
}
export const PAYMENT_REQUEST_DOC_NAME = 'Payment Request';
export const PAYMENT_DOC_NAME = 'Payment Receipt for Evaluation';
export const CAPA_DOC_NAME = 'CAPA Plan'; 
export const CAPA_PLAN_ANDOR_IMPLEMENTATION_ASSESSMENT_REPORT = 'CAPA Plan and/or Implementation Assessment Report'; 
export const IMPLEMENTATION_EVIDENCE_ASSESSMENT_REPORT = 'Implementation Evidence Assessment Report'; 
export const IMPLEMNTATION_REPORT_DOC_NAME = 'Implementation Evidence';
export const INSPECTION_AGENDA = 'Tentative Inspection Agenda';
export const CONFLICT_OF_INTEREST = 'Declaration of Conflict of Interest';
export const COUNTRY_REQUIREMENT = 'Country Requirement';
export const VISA = 'Traveling Documents (VISA, Yellow fever, etc.)';
export const PREPARATION_CHECKLIST = 'Preparation Checklist';
export const INSPECTION_REPORT = 'Inspection Report';
export const DEFICIENCY_REPORT = 'Deficieny Summary Report';
export const CLEARANCE_LETTER = 'Clearance Letter';
export const ATTENDANCE_SHEET = 'Opening and Closing Attendance Sheet';
export const INSPECTION_PHOTOS = 'Other Evidence, such as Photos';
export const SUSPENSION_LETTER_DOC_NAME = 'License Suspension Letter';
export const CANCELLATION_LETTER_DOC_NAME = 'License Cancellation Letter';
export const REVOCATION_LETTER_DOC_NAME = 'GMP Revocation Letter';
export const GMP_FINAL_PAYMENT_DOC_NAME = 'GMP Final Payment';
export const TASK_FORCE_REPORT_DOC_NAME = 'Task Force Report';
export const TASK_FORCE_REVIEW_MINUTE_DOC_NAME = 'Task Force Review Minute';
export const DECLARATIN_LETTER_LINE_EXEMPTION_INSPECTION ='Declaration letter for line exemption for inspection';
export const GMP_APPLICATION_FORM = 'GMP Application Form'

export const SERVICE_FEE_REFERENCE = 'Service Fee Reference';
export const INSPECTION_CHECKLIST = 'Inspection Checklist';
export const CONSENT_FORM_DOC = 'Signed Confidentiality Agreement';
export const ADDITIONAL_DOCS_FOR_INSPECTION = 'Additional Documents for Inspection';

export const APPLICATION_TYPE_NAME_RENEWAL = 'Renewal';
export const APPLICATION_TYPE_NAME_NEW = 'New';
export const APPLICATION_TYPE_NAME_CHANGE = 'Change';
export const APPLICATION_TYPE_NAME_TEMP_CHANGE = 'Change for Temporary COC'
export const APPLICATION_TYPE_NAME_REPLACEMENT = 'Replacement';
export const APPLICATION_TYPE_NAME_RETURN_COC = 'Return COC';
export const APPLICATION_TYPE_NAME_TEMP_RETURN_COC = 'Return Temporary COC';

export const APPLICATION_TYPE_CODE_NEW = 'NEW';
export const APPLICATION_TYPE_CODE_CHANGE = 'CHG';
export const APPLICATION_TYPE_CODE_RENEWAL = 'REN';
export const APPLICATION_TYPE_CODE_REPLACEMENT = 'REP';
export const APPLICATION_TYPE_CODE_RETURN_COC = 'RET';
export const APPLICATION_TYPE_NAME_TEMP_COC = 'Temporary COC for Covid-19';

export const APPLICATION_TYPE_CODE_ADD_WAREHOUSE = 'WHA';
export const APPLICATION_TYPE_CODE_TEMP_COC = 'TCC';
export const APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE = 'TWA';
export const APPLICATION_TYPE_CODE_TEMP_CHANGE = 'CTC';
export const APPLICATION_TYPE_CODE_TEMP_RETURN_COC = 'RTC';

export const APPLICATION_FLOW_TYPE_NAME_MAJOR = 'Major';
export const APPLICATION_FLOW_TYPE_NAME_MINOR = 'Minor';

export const APPLICATION_FLOW_TYPE_CODE_MINOR = 'MIN';
export const APPLICATION_FLOW_TYPE_CODE_MAJOR = 'MAJ';


export const APPLICATION_LIST_FIRST_LEVEL = 'APPLICATION_LIST_FIRST_LEVEL';
export const APPLICANT_ACTIONS = 'APPLICANT_ACTIONS';
export const WAREHOUSE_ADDITION_APPLICANT_ACTIONS = 'WAREHOUSE_ADDITION_APPLICANT_ACTIONS';
export const APPLICATION_LIST_SECOND_LEVEL = 'APPLICATION_LIST_SECOND_LEVEL';
export const DELETED_APPLICATIONS = 'DELETED_APPLICATIONS';
export const WAREHOUSE_ADDITION_APPLICATION_LIST = 'WAREHOUSE_ADDITION_APPLICATION_LIST';
export const TEMP_COC_APPLICATION_LIST = 'TEMP_COC_APPLICATION_LIST';
export const FACILITY_MENU = 'FACILITY_MENU';
export const FACILITY_CAT_MENU = 'FACILITY_CAT_MENU';
export const USERS_MENU = 'USERS_MENU';
export const SETTINGS_FIRST_LEVEL_MENU = 'SETTINGS_FIRST_LEVEL_MENU';
export const SUPER_ADMIN_SETTINGS_MENU = 'SUPER_ADMIN_SETTINGS_MENU';
export const SPECIFIC_PRODUCT_CONFIG_MENU = 'SPECIFIC_PRODUCT_CONFIG_MENU';
export const LEGACY_DATA_CONFIG_MENU = 'LEGACY_DATA_CONFIG_MENU';
export const ADMINISTRATOR_MENU = 'ADMINISTRATOR_MENU';

export const BANK_TRANSFER_SLIP = 'Bank Transfer Slip';
export const PROOF_OF_PAYMENT_FROM_EFDA_FINANCE = 'Proof of Payment from EFDA Finance';
export const GMP_FINAL_BANK_TRANSFER_SLIP = 'GMP Final Bank Transfer Slip';
export const GMP_FINAL_PROOF_OF_PAYMENT_FROM_EFDA_FINANCE = 'GMP Final Proof of Payment from EFDA Finance';

// branch offices
export const EFDA = 'EFDA';
export const DATA_ENTRY_CLERK_ACTIONS = 'DATA_ENTRY_CLERK_ACTIONS';



//Professional Document Names
export const PSE_EXPERIENCE_DOCUMENT = 'Experience Letter of Physico-chemical Expert';
export const MB_EXPERIENCE_DOCUMENT = 'Experience Letter of Microbiologist';
export const QA_EXPERIENCE_DOCUMENT = 'Experience Letter of Quality Assurance Supervisor Head';
export const PM_EXPERIENCE_DOCUMENT = 'Experience Letter of Production Manager';
export const HS_EXPERIENCE_DOCUMENT = 'Experience Letter of Hygiene and Sanitation Expert';
export const QC_EXPERIENCE_DOCUMENT = 'Experience Letter of Quality Control';
export const PLC_ESTABLISHMENT_DOCUMENT = 'Plc Establishment Letter';
export const PLC_ESTABLISHMENT_REGULATION_DOCUMENT = 'Establishment Regulation';


//chart types
export const PIECHART = 'pie';
export const BARCHART = 'bar';
export const HORIZONTALBARCHART = 'horizontalBar';
export const PIE_CHART = 'PieChart';
export const BAR_CHART = 'BarChart';
export const DUAL_COUNT = 'DualCount';
export const COUNT = 'Count';
export const HORIZONTAL_BAR_CHART = 'HorizontalBarChart';

//Report names
export const FACILITY_GRADE = 'Facility Grade Count';
export const FACILITY_BY_BRANCH = 'Facility By Branch';
export const COUNT_BY_STATUS_OF_APPS = 'Count By Status of Applications';
export const FACILITY_COUNT = 'Facility Count';

//Specific product items
export const SP_ITEM_GENERAL_MED_DEV = 'General Medical Devices';
export const SP_ITEM_DENTAL_EQUIP = 'Dental Equipments';
export const SP_ITEM_EYE_GLASS = 'Optical lenses and related product for medical use';
export const SP_ITEM_IN_VITRO_DIAGNOSTICS = 'In Vitro Diagnostics';
export const SP_ITEM_RADIOGRAPHY_DEV = 'Radiography Devices';

export const SP_ITEM_ALCOHOL_BASED_HAND_RUB = 'Alcohol based hand rub solution';
export const SP_ITEM_DISNFECTANT_SURFACE = 'Disinfectant for surfaces hypochlorite solution, 0.05%(regular cleaning) or  0.5%( disinfection of spill)';
export const SP_ITEM_APRON = 'Apron';
export const SP_ITEM_FACE_SHIELDS = 'Face shields'
export const SP_ITEM_GLOVES_NON_STERILE = 'Gloves, non-sterile';
export const SP_ITEM_GLOVES_STERILE = 'Gloves, sterile';
export const SP_ITEM_GOOGLES = 'Goggles';
export const SP_ITEM_COVER_GOWN = 'Cover all gown';
export const SP_ITEM_SHOE_COVER = 'Shoe cover';
export const SP_ITEM_MEDICAL_MASK = 'Medical mask';
export const SP_ITEM_RESPIRATOR = 'Respirator (N95/PPF2)';
export const SP_ITEM_LAB_SCREENING_KIT = 'Lab screening test kit';
export const SP_ITEM_LAB_CONFIRMATION_KIT = 'Lab confirmation test kit';
export const SP_ITEM_RT_PCR_KIT = 'RT-PCR kit';
export const SP_ITEM_EXTRACTION_KIT = 'Extraction kit';
export const SP_ITEM_CARTRIDGES = 'Cartridges for RT-PCR automatic system';
export const SP_ITEM_SWAB = 'Swab and viral transport medium';
export const SP_ITEM_PULSE_OXIMETER = 'Pulse oximeter';
export const SP_ITEM_CONCENTRATOR = 'Concentrator 02, 10L,230V,50Hz+acc';
export const SP_ITEM_NASAL_OXYGEN_CANNULA = 'Nasal oxygen cannula, with prongs';
export const SP_ITEM_VENTILATOR_PATIENT = 'Ventilator patient, for adult, pediatric w/acc';
export const SP_ITEM_IR_THERMOMETER = 'IR thermometer';
export const SP_ITEM_CPAP = 'CPAP, with tubing and patient interfaces for adult and pediatric, w/acc';
export const SP_ITEM_SUCTION_PUMP = 'Suction pump, mechanical';
export const SP_ITEM_HIGH_FLOW_NASAL_CANNULA = 'High-flow nasal cannula (HFNC) w/azcc';
export const SP_ITEM_STERILE_MEDICAL_MASK = 'Sterile medical Face mask';
export const SP_ITEM_NON_STERILE_MEDICAL_MASK = 'Non-sterile medical Face mask';
export const SP_ITEM_COVID_TEST_KIT = 'COVID-19 IgG/IgM test kit';


//Specific products
export const SP_ANTISEPTIC_DISENFECTANT = 'Antiseptic and disinfectant';
export const SP_SMALL_SCALE_MED_DEVICE = 'Small Scale Medical Device';
export const SP_PHARM_MED_CHEMICALS = 'Pharmaceuticals and Medicinal Chemicals for Human Use';
export const SP_HUMAN_MED_SUPS = "Human Medicine, Medical Supplies and Equipments";
export const SP_PHARM_RAW_MATERIALS = "Pharmaceutical Raw materials and inputs";

//CheckList
export const CHECK_LIST_CONST_PARTIALLY_COMPLETED = 'Is the facility construction under construction or partially completed?';


// Professional Fields Label
export const EXPERIENCE_LABEL = 'Experience';
export const QUALIFICATION_LABEL = 'Qualification';
export const EDUCATION_LEVEL_LABEL = 'Education Level';
export const QUAL_EDU_ASSOCIATION_LABEL = 'Education Level and Qual. Association';
export const EDUCATION_LEVEL_CODE = 'EDL';
export const QUAL_CODE = 'QUA';

export const STATUS_CHANGE_MODAL_MAP = {
  [INSPECTED_CODE]              : {'title' : 'Pass Inspection', 'buttonLabel' : PASS },
  [INSPECTION_FAILED_CODE]      : {'title' : 'Fail Inspection', 'buttonLabel' : FAIL },
  [SUBMIT_FOR_APPROVAL_CODE]    : {'title' : 'Submit For Approval', 'buttonLabel' : PASS },
  [RETURN_TO_INSPECTOR_CODE]    : {'title' : 'Return to Inspector', 'buttonLabel' : RETURN },
  [RETURN_TO_INSPECTOR_TEAM_LEADER_CODE] : {'title' : 'Return to Inspector Team Leader', 'buttonLabel' : RETURN },
  [SUBMIT_FOR_REJECTION_CODE]   : {'title' : 'Submit For Rejection', 'buttonLabel' : FAIL },
  [INSPECTION_REJECTED_CODE]    : {'title' : 'Reject Inspection', 'buttonLabel' : FAIL },
  [RETURN_TO_CSO_CODE]          : {'title' : 'Return to CSO', 'buttonLabel' : RETURN },
  [SELF_INSPECTION_FAILED_CODE] : {'title' : 'Fail Self Inspection', 'buttonLabel' : FAIL },
  [SELF_INSPECTION_PASSED_CODE] : {'title' : 'Pass Self Inspection', 'buttonLabel' : PASS },
  [FIR_REQUESTED]               : {'title' : 'Request FIR', 'buttonLabel' : REQUEST },
  [FIR_SUBMITTED]               : {'title' : 'Submit FIR', 'buttonLabel' : SUBMIT },
  [QUARANTINED]                 : {'title' : 'Quarantine', 'buttonLabel' : QUARANTINE },
  [UNDO_QUARANTINE]             : {'title' : 'Undo Quarantine', 'buttonLabel' : UNDO_QUARANTINE_LABEL },
  [RETURN_TO_APPLICANT_CODE]    : {'title' : 'Return to Applicant', 'buttonLabel' : RETURN},
  [INFO_FOR_INSPECTION_REQUESTED] : {'title' : 'Request Information for Inspection', 'buttonLabel' : REQUEST},
  [FIR_REQUESTED_AFTER_INSPECTION]: {'title' : 'Request FIR', 'buttonLabel' : REQUEST },
  [FIR_SUBMITTED_AFTER_INSPECTION]: {'title' : 'Submit FIR', 'buttonLabel' : SUBMIT },
}

// production category types
export const CATEGORY_A = 'Category A';
export const CATEGORY_B = 'Category B';
export const CATEGORY_C = 'Category C';

export const ILISCENCE_MODULE_CODE = 'ILIC';